module.exports = __webpack_public_path__ + "static/media/ic_girl.c2152db9.svg";